import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import api from "../../../services/api";

import { Company } from "../../../models/entities/company";

import { notification } from "antd";

import { Button, ContentName, Modal, Table } from "./style";

type CompanyUsers = {
  user_id: number;
  full_name: string;
};

interface IProps {
  visible: boolean;
  setVisible: Dispatch<SetStateAction<boolean>>;
  company?: Company;
  profiles?: { id: number; name: string }[];
}

const UsersCompanyModal: React.FC<IProps> = ({
  visible,
  setVisible,
  company,
  profiles,
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [shouldSearch, setShouldSearch] = useState<boolean>(false);
  const [isRegister, setIsRegister] = useState<boolean>(false);
  const [companyUsers, setCompanyUsers] = useState<CompanyUsers[]>([]);

  useEffect(() => {
    const fetchCompaniesUsers = async () => {
      setLoading(true);
      try {
        const {
          data: { content },
        } = await api.get(`/companyUser/${company?.id}/company`);
        setCompanyUsers(content);

        const findUserRegister = content
          .filter((_user) => _user.template_track_status)
          .some((_users) =>
            _users.user_template_track_stores.some((_id) => _id === company?.id)
          );
        setIsRegister(() => findUserRegister);
      } catch (e) {
        const _description =
          //@ts-ignore
          e?.response?.data?.message || "Falha ao obter usuários";
        notification.error({
          message: "Falha ao obter empresas do usuário",
          description: _description,
          duration: 5,
        });
      } finally {
        setLoading(false);
        setShouldSearch(false);
      }
    };
    if ((visible && company) || shouldSearch) {
      fetchCompaniesUsers();
    }
  }, [visible, company, shouldSearch]);

  const registerTemplate = async (userSelect, action) => {
    try {
      setLoading(true);
      let user_stores: number[] = [];

      if (action === "send" && company?.id) {
        user_stores = userSelect?.user_template_track_stores?.length
          ? [...userSelect?.user_template_track_stores]
          : [];
        user_stores.push(company.id);
      } else {
        user_stores = userSelect?.user_template_track_stores?.filter(
          (_companyId) => _companyId !== company?.id
        );
      }

      const method = userSelect?.template_track_status ? "put" : "post";
      const url = userSelect?.template_track_status
        ? `/template-track/users/update-user/${userSelect.user_id}`
        : `/template-track/users/create-user/${userSelect.user_id}`;

      await api[method](url, {
        companyIds: user_stores,
      });

      notification.success({
        message: `Usuário ${
          action === "send" ? "vinculado" : "desvinculado"
        } com sucesso`,
        duration: 5,
      });

      setShouldSearch(true);
    } catch (e) {
      const _description =
        //@ts-ignore
        e?.content?.data?.message || "";
      notification.error({
        message: "Erro ao vincular usuário",
        description: _description,
        duration: 5,
      });
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "ID do Usuário",
      dataIndex: "user_id",
      key: "user_id",
      width: "15%",
    },
    {
      title: "Nome",
      dataIndex: "full_name",
      key: "full_name",
      ellipsis: true,
      render: (text) => (
        <ContentName>
          <span>{text}</span>
        </ContentName>
      ),
    },
    {
      title: "Perfil",
      dataIndex: "profile",
      key: "profile",
      ellipsis: true,
      render: (text, record) => (
        <ContentName>
          <span>
            {profiles?.find((_profile) => _profile.id === text)?.name}
          </span>
          <b style={{ marginLeft: "0.2rem", color: "var(--red-600)" }}>
            {company?.companyFranchisee?.find(
              (_user) => _user?.check_notification
            )?.user_id === record?.user_id
              ? "( R )"
              : ""}
          </b>
        </ContentName>
      ),
    },
    {
      title: "Ações",
      dataIndex: "more",
      key: "more",
      width: "25%",
      render: (_, record) => (
        <div>
          {!isRegister ? (
            <Button
              actionType={!isRegister ? "activate" : "inactivate"}
              type="primary"
              onClick={() => {
                registerTemplate(record, "send");
              }}
              loading={loading}
            >
              {"Vincular usuário"}
            </Button>
          ) : (
            <Button
              actionType={
                record.user_template_track_stores &&
                record?.user_template_track_stores?.some(
                  (_store) => _store === company?.id
                )
                  ? "inactivate"
                  : "activate"
              }
              type="primary"
              onClick={() => registerTemplate(record, "remove")}
              loading={loading}
              disabled={
                record.user_template_track_stores &&
                record?.user_template_track_stores?.some(
                  (_store) => _store === company?.id
                )
                  ? false
                  : true
              }
            >
              {record.user_template_track_stores &&
              record?.user_template_track_stores?.some(
                (_store) => _store === company?.id
              )
                ? "Desvincular usuário"
                : "Vincular Usuário"}
            </Button>
          )}
        </div>
      ),
    },
  ];

  return (
    <Modal
      title={<span className="title">Usuários Vinculados</span>}
      visible={visible}
      onCancel={() => setVisible(false)}
      width={900}
      centered
      footer={null}
    >
      <span className="span-info">
        Cada loja pode possuir apenas um usuário cadastrado na Template Track
      </span>
      <Table
        columns={columns}
        pagination={false}
        scroll={{ y: 300 }}
        dataSource={companyUsers.map((entity) => ({
          key: entity.user_id,
          ...entity,
        }))}
        loading={loading}
      />
    </Modal>
  );
};

export default UsersCompanyModal;
